/**
 * Cohesive ChatKit — identity/spectrum tints for chat chrome (file-type marks,
 * attachment chips, favicon monograms, mention glyphs).
 *
 * Ported from cohesive-design-system/showcase/lib/chat-kit.jsx.
 */
export type ChatTint =
  | "rust"
  | "teal"
  | "sage"
  | "gold"
  | "plum"
  | "blue"
  | "orange"
  | "mulberry";

export const TINT_BG: Record<ChatTint, string> = {
  rust: "bg-rust",
  teal: "bg-teal",
  sage: "bg-sage",
  gold: "bg-gold",
  plum: "bg-plum",
  blue: "bg-spectrum-blue",
  orange: "bg-spectrum-orange",
  mulberry: "bg-spectrum-mulberry",
};

export const FAV_TINTS: ChatTint[] = [
  "rust",
  "teal",
  "plum",
  "sage",
  "gold",
  "blue",
  "mulberry",
  "orange",
];

/** Stable ext → tint assignment for attachment chips (CSV→sage, PDF→gold, …). */
export function tintForExt(ext: string): ChatTint {
  const map: Record<string, ChatTint> = {
    csv: "sage",
    xls: "sage",
    xlsx: "sage",
    pdf: "gold",
    doc: "blue",
    docx: "blue",
    md: "teal",
    txt: "teal",
    png: "plum",
    jpg: "plum",
    jpeg: "plum",
    gif: "plum",
    webp: "plum",
    mp4: "mulberry",
    mov: "mulberry",
    mp3: "orange",
    wav: "orange",
    json: "rust",
    zip: "rust",
  };
  return map[ext.toLowerCase()] ?? "sage";
}
